import { Component } from 'react';

export class GreenTickStatusSVG extends Component<{
    className?: string;
    'data-testid'?: string;
}> {
    render() {
        const { className } = this.props;

        return (
            <svg
                className={className}
                data-testid={this.props['data-testid']}
                fill="none"
                width="20px"
                height="20px"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
            >
                <path
                    d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM7 11.4L3.6 8 5 6.6l2 2 4-4L12.4 6 7 11.4z"
                    fill="#00B67A"
                />
            </svg>
        );
    }
}
